import PropTypes from 'prop-types';
import React from 'react';
import {findDOMNode} from 'react-dom';
import debounce from 'lodash/debounce';

class SearchField extends React.Component {
  static defaultProps = {
    initialValue: '',
    minCharacters: 3,
    debounceDelay: 1000,
    autoFocus: true,
  };

  static propTypes = {
    debounceDelay: PropTypes.number,
    initialValue: PropTypes.string,
    minCharacters: PropTypes.number,
    onSearch: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    autoFocus: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      val: props.initialValue || '',
    };
  }

  componentWillMount() {
    this.delayedSearch = debounce(this.props.onSearch, this.props.debounceDelay);
  }

  componentDidMount() {
    // Set cursor to end of string on initialize for IE and Firefox
    if (this.search && this.props.initialValue && this.props.initialValue.length > 0) {
      findDOMNode(this.search).selectionStart = this.props.initialValue.length; // eslint-disable-line react/no-find-dom-node
    }
  }

  _setValue = val => {
    this.setState({val});
  };

  get value() {
    return this.state.val;
  };

  handleChange = (e) => {
    this.setState({val: this.search.value});
    if (e.target.value && e.target.value.length >= this.props.minCharacters) {
      this.delayedSearch(this.search.value);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSearch(this.value, true);
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className='search-field bl bl-search'>
          <input type='text'
                 ref={r => this.search = r}
                 className='form-control'
                 autoFocus={this.props.autoFocus}
                 onChange={this.handleChange}
                 value={this.state.val}
                 placeholder={this.props.placeholder}
                 maxLength="100" />
          <div style={{position: 'absolute', width: 40, cursor: 'pointer', top: 0, right: 0, bottom: 0}} onClick={this.handleSubmit} />
        </div>
      </form>
    );
  }
}

export default SearchField;
